import React, { useEffect, useState } from "react";
import {
  Typography,
  ListItem,
  Button,
  Divider,
  Collapse,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Avatar,
  Tooltip,
  Checkbox,
} from "@material-ui/core";
import { FixedSizeList } from "react-window";
import { makeStyles } from "@material-ui/core/styles";
import AutoSizer from "react-virtualized-auto-sizer";
import {
  Add,
  List,
  Check,
  Delete,
  CloudDownload,
  Home,
} from "@material-ui/icons";
import axios, { reportClient } from "../../../AxiosClient";
import ChartStepTwo from "./ChartStepTwo";
import DataSourceDefinition from "./DataSourceDefinition";

import { useTranslation, Trans } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: 150,
  },
  existingContainer: {
    display: "flex",
    flex: 1,
    minHeight: 250,
  },
  list: {
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    flex: 1,
  },
  selectSource: {
    textAlign: "center",
    justifyContent: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  existing: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: 10,
  },
  newButton: {
    margin: "10px auto",
  },
  collapse: {
    marginTop: 15,
  },
  expansionPanel: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  },
  expansionPanelExpanded: {
    margin: "0 !important",
  },
  expansionPanelSummary: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
  },
  formControl: {
    marginBottom: 5,
  },
}));

const redirect = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? ":" + window.location.port : ""
}/oauth2/redirect`;
function ReportingStepDataSource(props) {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [createNew, setCreateNew] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saveSourceForReuse, setSaveSourceForReuse] = useState(false);

  const [authentication, setAuthentication] = useState({
    requestTokenMethod: "Parameters",
    authMethod: "None",
    type: "Document",
    query: "Favourites",
    radioChoice: "Internal",
    oAuthFilters: [],
    oAuthTokenFilters: [],
    authentication: "",
    radioDataSendMethodChange: "Parameters",
    oAuthURL: "",
    oAuthIdName: "client_id",
    oAuthId: "",
    redirectParamName: "redirect_uri",
    token: "",
    respondTokenName: "access_token",
    apiKeyMethod: "Parameter",
    apiKeyParamName: "apikey",
    apiKeyValue: "",
    username: "",
    password: "",
    state: null,
    codeVerifier: null,
    codeChallenge: null,
  });

  const [token, setToken] = useState(null);
  const [expanded, setExpanded] = useState("definition");
  const [dataBreadcrumbs, setDataBreadcrumbs] = useState([]);
  const [url, setUrl] = useState("");
  const [filters, setFilters] = useState([]);
  const [query, setQuery] = useState("");
  const [selectedSource, setSelectedSource] = useState(null);
  const { t } = useTranslation();
  // const [userSortColumns, setUserSortColumns] = useState([]);
  // const [documentSortColumns, setDocumentSortColumns] = useState([]);

  // useEffect(() => {
  //   reportClient.get("/sortcolumns/user/").then((res) => {
  //     setUserSortColumns(res.data);
  //   });
  // }, []);

  // useEffect(() => {
  //   reportClient.get("/sortcolumns/document/").then((res) => {
  //     setDocumentSortColumns(res.data);
  //   });
  // }, []);

  useEffect(() => {
    reportClient.get("/datasource/", { withCredentials:true }).then((res) => {
      setData(res.data);
    });
  }, []);

  useEffect(
    () => {
      props.handleAuthenticationChange &&
        props.handleAuthenticationChange(authentication);
    },
    [authentication]
  );

  const onSourceClick = (index) => {
    setSelectedSource(data[index]);
  };
  const onRowClick = (selected) => {
    let rowData = selected;
    let chart = {
      ...props.chart,
      dataUrl: rowData.url,
      dataFilters: rowData.filters ? JSON.parse(rowData.filters) : [],
      dataBreadcrumbs: JSON.parse(rowData.dataTraversal),
      query: rowData.query ? rowData.query : "",
    };
    props.handleChartChange(chart);
    props.handleAuthenticationChange(JSON.parse(rowData.authentication));
    JSON.parse(rowData.authentication).authMethod === "OAuth"
      ? authGraphDomainForData(
          JSON.parse(rowData.authentication),
          rowData.filters ? JSON.parse(rowData.filters) : [],
          rowData.url,
          rowData.query ? rowData.query : "",
          JSON.parse(rowData.dataTraversal),
          chart
        )
      : getData(
          null,
          JSON.parse(rowData.authentication),
          rowData.filters ? JSON.parse(rowData.filters) : [],
          rowData.url,
          rowData.query ? rowData.query : "",
          JSON.parse(rowData.dataTraversal),
          chart
        );
  };

  const getData = (
    token,
    auth,
    dataFilters,
    dataUrl,
    query,
    breadcrumbs,
    chart
  ) => {
    if (auth.radioChoice === "External") {
      let config = {
        // headers: { "Access-Control-Allow-Origin": "*" },
        withCredentials:true,
      };
      let parameters = "?";
      if (auth.authMethod === "OAuth") {
        config = {
          ...config,
          headers: { Authorization: `Bearer ${token}` },
        };
        if (auth.requestTokenMethod === "Parameters") {
          parameters = `${parameters}access_token=${token}&`;
        }
      }
      if (auth.authMethod === "ApiKey") {
        if (auth.apiKeyMethod === "Parameter") {
          parameters = `${parameters}${auth.apiKeyParamName}=${
            auth.apiKeyValue
          }&`;
        }
      }
      let body = {};
      if (auth.radioDataSendMethodChange === "Parameters") {
        dataFilters.map(
          (filter) =>
            (parameters =
              parameters + filter.filterName + "=" + filter.filterValue + "&")
        );
      } else {
        dataFilters.map(
          (filter) => (body[filter.filterName] = filter.filterValue)
        );
      }
      axios.get(dataUrl + parameters, body, config).then((res) => {
        doBreadcrumbs(res.data, breadcrumbs, chart);
      });
    } else if (auth.radioChoice === "Internal") {
      reportClient({
        url: "/graphql",
        method: "post",
        data: query,
      }).then((res) => {
        doBreadcrumbs(res.data, breadcrumbs, chart);
      });
      return;
    }
  };

  const authGraphDomainForData = (
    auth,
    dataFilters,
    dataUrl,
    query,
    breadcrumbs,
    chart
  ) => {
    let oAuthURL = auth.oAuthURL;
    if (!oAuthURL) return;
    oAuthURL =
      oAuthURL +
      "?" +
      auth.oAuthIdName +
      "=" +
      auth.oAuthId +
      "&" +
      auth.redirectParamName +
      "=" +
      redirect;
    auth.oAuthFilters.map(
      (filter) =>
        (oAuthURL =
          oAuthURL + "&" + filter.filterName + "=" + filter.filterValue)
    );
    openPopup(
      oAuthURL,
      (location) => {
        let url = new URL(location);
        let split = url.href.split("access_token=");
        split = split[1].split("&");
        let token = split[0];
        getData(token, dataFilters, dataUrl, query, breadcrumbs, chart);
      },
      (message) => {
        console.log(message);
      }
    );
  };

  const openPopup = (
    url,
    successCallback,
    errCallback,
    redirectUrl = redirect
  ) => {
    let popUpWidth = 483;
    let popUpHeight = 600;
    let winLeft = window.screenLeft ? window.screenLeft : window.screenX;
    let winTop = window.screenTop ? window.screenTop : window.screenY;
    let width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    let height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    let left = width / 2 - popUpWidth / 2 + winLeft;
    let top_1 = height / 2 - popUpHeight / 2 + winTop;
    let popup = window.open(
      url,
      "",
      "width=" +
        popUpWidth +
        ", height=" +
        popUpHeight +
        ", top=" +
        top_1 +
        ", left=" +
        left
    );
    var pollTimer = window.setInterval(() => {
      if (popup && popup.closed) {
        window.clearInterval(pollTimer);
        errCallback();
      } else {
        try {
          var popUpWindowLocation = popup.location;
          if (popUpWindowLocation.href.indexOf(redirectUrl) !== -1) {
            window.clearInterval(pollTimer);
            popup.close();
            successCallback(popUpWindowLocation);
          }
        } catch (e) {
          // we will catch a cross origin error every time we try to access the popup until it redirects, ignore it
        }
      }
    }, 1);
  };

  const renderRow = (props) => {
    const { index, style } = props;
    let rowData = data[index];
    let auth = JSON.parse(rowData.authentication);
    return (
      <ListItem
        selected={selectedSource && selectedSource.id === rowData.id}
        button
        ContainerProps={{ style: style }}
        ContainerComponent="div"
        key={index}
        onClick={() => onSourceClick(index)}
        dense
      >
        <ListItemAvatar>
          <Tooltip
            title={
              auth.radioChoice === "Internal"
                ? t("reporting_data_source_internal_data")
                : t("reporting_data_source_external_data")
            }
          >
            <Avatar>
              {auth.radioChoice === "Internal" ? <Home /> : <CloudDownload />}
            </Avatar>
          </Tooltip>
        </ListItemAvatar>
        <ListItemText primary={rowData.name} secondary={rowData.description} />
        <ListItemSecondaryAction>
          <IconButton edge="end" onClick={() => deleteDatasource(index)}>
            <Delete />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  const deleteDatasource = (index) => {
    reportClient.delete(`/datasource/${data[index].id}`, { withCredentials:true }).then(() => {
      reportClient.get("/datasource/", { withCredentials:true }).then((res) => {
        setData(res.data);
      });
    });
  };

  const doBreadcrumbs = (data, breadcrumbs, chart) => {
    let array =
      authentication.radioChoice === "Internal"
        ? data.data[Object.keys(data.data)[0]]
        : data;
    breadcrumbs.map((header) => {
      array = array[header.value];
    });
    props.handleChartChange({ ...chart, data: array });
    props.handleKeyChange(Object.keys(array[0]));
    props.handleNext();
  };

  const saveDatasource = () => {
    reportClient
      .post("/datasource/", {
        name,
        description,
        internal: authentication.radioChoice === "Internal",
        url,
        authentication: JSON.stringify(authentication),
        dataTraversal: JSON.stringify(dataBreadcrumbs),
        filters: JSON.stringify(filters),
        query: JSON.stringify(query),
      })
      .then((res) => {
        let filtersOptional = filters;
        if (typeof filtersOptional === "string") {
          filtersOptional = [];
        }
        props.handleChartChange({
          ...props.chart,
          dataUrl: url,
          dataFilters: filtersOptional,
          dataBreadcrumbs,
          query: JSON.stringify(query),
        });
        props.handleAuthenticationChange(authentication);
        props.handleNext();
      });
  };
  const useDatasource = () => {
    let filtersOptional = filters;
    if (typeof filtersOptional === "string") {
      filtersOptional = [];
    }
    props.handleChartChange({
      ...props.chart,
      dataUrl: url,
      dataFilters: filtersOptional,
      dataBreadcrumbs,
      query: JSON.stringify(query),
    });
    props.handleAuthenticationChange(authentication);
    props.handleNext();
  };
  return (
    <div>
      <Typography variant="h6">
        <Trans i18nKey="reporting_data_source_header" />
      </Typography>
      <Typography variant="body2" gutterBottom>
        <Trans i18nKey="reporting_data_source_subheader" />
      </Typography>
      <div className={classes.container}>
        <Button
          autoFocus
          variant="outlined"
          startIcon={<>{createNew ? <List /> : <Add />}</>}
          onClick={() => setCreateNew(!createNew)}
          className={classes.newButton}
        >
          {createNew
            ? t("reporting_data_source_button_select_existing")
            : t("reporting_data_source_button_select_new")}
        </Button>
        <Divider variant="middle" />
        <Collapse in={createNew} className={classes.collapse}>
          <Typography variant="h6">
            <Trans i18nKey="reporting_data_source_button_create_new" />
          </Typography>
          {/* <ExpansionPanel
            expanded={expanded === "definition"}
            onChange={(e, isExpanded) =>
              setExpanded(isExpanded ? "definition" : false)
            }
            classes={{
              root: classes.expansionPanel,
              expanded: classes.expansionPanelExpanded,
            }}
          > */}
          {/* <ExpansionPanelSummary
              classes={{ root: classes.expansionPanelSummary }}
            >
              <Typography>
                <Trans i18nKey="reporting_basic_data_source_details" />
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails> */}

          <FormControl
            component="fieldset"
            className={classes.formControl}
            style={{ marginTop: 15 }}
          >
            <FormLabel component="legend">{t("report_datasource")}</FormLabel>
            <RadioGroup
              style={{
                display: "flex",
                flexDirection: "row",
              }}
              onChange={(event) =>
                setAuthentication({
                  ...authentication,
                  radioChoice: event.target.value,
                })
              }
              aria-label="gender"
              name="customized-radios"
              value={authentication.radioChoice}
            >
              <FormControlLabel
                value="Internal"
                control={<Radio />}
                label={t("report_datasource_internal")}
              />
              <FormControlLabel
                value="External"
                control={<Radio />}
                label={t("report_datasource_external")}
              />
            </RadioGroup>
          </FormControl>
          <DataSourceDefinition
            authentication={authentication}
            onAuthenticationUpdate={(auth) => {
              setAuthentication(auth);
            }}
            onNameUpdate={(name) => setName(name)}
            onDescriptionUpdate={(description) => setDescription(description)}
            onTokenUpdate={(token) => setToken(token)}
            onSave={() => setExpanded("data")}
          />
          {/* </ExpansionPanelDetails>
          </ExpansionPanel> */}
          <ExpansionPanel
            expanded={
              expanded === "data" || authentication.radioChoice === "Internal"
            }
            onChange={(e, isExpanded) =>
              setExpanded(isExpanded ? "data" : false)
            }
            classes={{
              root: classes.expansionPanel,
              expanded: classes.expansionPanelExpanded,
            }}
          >
            <ExpansionPanelSummary
              classes={{ root: classes.expansionPanelSummary }}
            >
              <Typography>
                <Trans i18nKey="reporting_data_definition" />
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div style={{ width: "100%" }}>
                <ChartStepTwo
                  {...props}
                  dataUrl={url}
                  authentication={authentication}
                  dataBreadcrumbs={dataBreadcrumbs}
                  setDataBreadcrumbs={(b) => setDataBreadcrumbs(b)}
                  setDataUrl={(url) => setUrl(url)}
                  onFilterUpdate={(filters) => setFilters(filters)}
                  onQueryUpdate={(query) => setQuery(query)}
                  handleDataChange={props.handleDataChange}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={saveSourceForReuse}
                      value="saveSource"
                      onChange={(e) => setSaveSourceForReuse(e.target.checked)}
                    />
                  }
                  label={t("report_save_source_for_reuse")}
                />
                <Collapse in={saveSourceForReuse} className={classes.collapse}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                    }}
                  >
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <TextField
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                        value={name}
                        id="data-source-name"
                        type="name"
                        label={t("report_datasource_name")}
                      />
                    </FormControl>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <TextField
                        onChange={(e) => {
                          setDescription(e.target.value);
                        }}
                        value={description}
                        id="data-source-description"
                        type="description"
                        label={t("report_datasource_description")}
                      />
                    </FormControl>
                  </div>
                </Collapse>
                {saveSourceForReuse ? (
                  <Button
                    disabled={
                      !props.data ||
                      props.data.length === 0 ||
                      saveSourceForReuse === false ||
                      name.length === 0
                    }
                    style={{ width: "100%", marginTop: 10 }}
                    onClick={() => {
                      saveDatasource();
                    }}
                    id="save-and-use-data-source"
                    startIcon={<Check />}
                  >
                    <Trans i18nKey="reporting_button_save_and_use" />
                  </Button>
                ) : (
                  <Button
                    style={{ width: "100%", marginTop: 10 }}
                    onClick={() => {
                      useDatasource();
                    }}
                    id="use-data-source"
                    startIcon={<Check />}
                  >
                    <Trans i18nKey="report_button_use" />
                  </Button>
                )}
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </Collapse>
        <Collapse in={!createNew} className={classes.collapse}>
          <Typography variant="h6" gutterBottom>
            <Trans i18nKey="reporting_data_source_button_select_existing" />
          </Typography>
          <div className={classes.existingContainer} id="existing-data-sources">
            <div className={classes.list}>
              <AutoSizer>
                {({ height, width }) => (
                  <FixedSizeList
                    height={height}
                    width={width}
                    itemCount={data.length}
                    itemSize={55}
                  >
                    {renderRow}
                  </FixedSizeList>
                )}
              </AutoSizer>
            </div>
            <div className={classes.existing}>
              {selectedSource ? (
                <>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                    id="existing-data-source-details"
                  >
                    <TextField
                      // onChange={e => {
                      //   setName(e.target.value);
                      // }}
                      disabled
                      value={selectedSource.name}
                      type="name"
                      label={t("reporting_data_source_name")}
                    />
                  </FormControl>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <TextField
                      // onChange={e => {
                      //   setSelectedSource(e.target.value);
                      // }}
                      disabled
                      value={selectedSource.description}
                      type="description"
                      label={t("reporting_data_source_description")}
                    />
                  </FormControl>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedSource.internal}
                        disabled
                        value="checkedA"
                      />
                    }
                    label={t("reporting_data_source_internal_data")}
                  />
                  {selectedSource.internal ? (
                    <>
                      <FormControl style={{ width: "25%" }}>
                        <InputLabel>{t("report_get_stats_for")}</InputLabel>
                        <Select
                          disabled
                          MenuProps={{
                            style: { zIndex: 1310 },
                          }}
                          value={
                            selectedSource.query.includes("getUserStats")
                              ? "users"
                              : "documents"
                          }
                          inputProps={{
                            name: "statsFor",
                            id: "statsFor",
                          }}
                        >
                          <MenuItem key="fontSize" value={"users"}>
                            <Trans i18nKey="global_user_plural" />
                          </MenuItem>
                          <MenuItem key="fontSize" value={"documents"}>
                            <Trans i18nKey="global_document_plural" />
                          </MenuItem>
                        </Select>
                      </FormControl>
                      {/* <FormControl style={{ width: "25%" }}>
                        <InputLabel>Sort Column</InputLabel>
                        <Select
                          disabled
                          value={"sortColumn"
                          }
                          inputProps={{
                            name: "sortColumn",
                            id: "sortColumn",
                          }}
                        >
                          {this.userSortColumns.map((column,idx) => {
                            return (
                              <MenuItem key={idx + "-sortcol"} value={column}>
                                {column}
                              </MenuItem>
                            )

                          })}
                            
                        </Select>
                      </FormControl> */}
                      <FormControl disabled style={{ marginTop: 10 }}>
                        <FormLabel component="legend">
                          {t("report_show_stats_for")}
                        </FormLabel>
                        <RadioGroup
                          aria-label="all or specific"
                          name="all_specific"
                          value={
                            selectedSource.query.includes("[]")
                              ? "all"
                              : "specific"
                          }
                          // onChange={handleRadioChange}
                        >
                          <FormControlLabel
                            value="all"
                            control={<Radio />}
                            label={t("report_all_users")}
                          />
                          <FormControlLabel
                            value="specific"
                            control={<Radio />}
                            label={t("report_specific_users")}
                          />
                        </RadioGroup>
                      </FormControl>
                    </>
                  ) : (
                    <>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <TextField
                          // onChange={e => {
                          //   setSelectedSource(e.target.value);
                          // }}
                          disabled
                          value={selectedSource.url}
                          type={t("reporting_data_source_url")}
                        />
                      </FormControl>
                    </>
                  )}

                  <Button
                    disabled={!props.data || props.data.length === 0}
                    onClick={() => {
                      onRowClick(selectedSource);
                    }}
                    startIcon={<Check />}
                  >
                    <Trans i18nKey="reporting_use_this_source_button" />
                  </Button>
                </>
              ) : (
                <div className={classes.selectSource}>
                  <Trans i18nKey="reporting_select_a_data_source" />
                </div>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
}

export default ReportingStepDataSource;
